// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationStatus } from './priorAuthorizationStatus.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationStatusDetails {
    'status': PriorAuthorizationStatus;
    'updatedDateTime'?: Moment;
    'approvalEffectiveStartDate'?: Moment;
    'approvalEffectiveEndDate'?: Moment;
    'authorizationNumber'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationStatusDetails>> = [
        {
            "name":     "status",
            "baseName": "status",
            "type":     "PriorAuthorizationStatus"
        },
        {
            "name":     "updatedDateTime",
            "baseName": "updatedDateTime",
            "type":     "Date"
        },
        {
            "name":     "approvalEffectiveStartDate",
            "baseName": "approvalEffectiveStartDate",
            "type":     "Date"
        },
        {
            "name":     "approvalEffectiveEndDate",
            "baseName": "approvalEffectiveEndDate",
            "type":     "Date"
        },
        {
            "name":     "authorizationNumber",
            "baseName": "authorizationNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationStatusDetails.attributeTypeMap;
    }
}
